module.exports = __webpack_public_path__ + "static/information-page-level-example-c650f38ed3004952c86ca4f0b20ae902.svg";